export const FILTER_DEBOUNCE_DELAY = 200;

// Maximum rows a single "All records" export can fetch. Mirrors the upstream
// CECP export API limit (and the BFF's EuqFeedbackExportReqDto).
export const EUQ_EXPORT_LIMIT = 10000;
